import { Flex } from "@aws-amplify/ui-react"
import { bslOrgId } from "@strtmn/sds/config"
import { useContext } from "react"
import { FaTractor } from "react-icons/fa6"
import { NavLink } from "react-router-dom"
import { UserDataContext } from "../contexts"
import {
  getLinkToVehicleCanTraces,
  getLinkToVehicleDebug,
  getLinkToVehicleEuDataAct,
  getLinkToVehicleOverview,
} from "../LinkUtils"
import "./PageHeader.css"

interface VehiclePageHeaderProps {
  vin: string
}
const icon = <FaTractor className="w-5 _h-3.5_ relativ text-[#3E9E29]" />
export default function VehiclePageHeader({ vin }: VehiclePageHeaderProps) {
  const { userData } = useContext(UserDataContext)
  const bslOrg = userData?.Organizations.find((o) => o.id === bslOrgId)
  const userIsInBslOrg = !!bslOrg
  const minimalVehicle = { vin: vin }
  const links: { title: string; url: string; end?: boolean }[] = [
    {
      title: "Übersicht",
      url: getLinkToVehicleOverview(minimalVehicle),
      end: true,
    },
    { title: "Rohdaten", url: getLinkToVehicleDebug(minimalVehicle) },
  ]
  if (userIsInBslOrg) {
    const bslLinks = [
      { title: "CAN-Traces", url: getLinkToVehicleCanTraces(minimalVehicle) },
    ]
    for (const link of bslLinks) {
      links.push(link)
    }
  }
  links.push({
    title: "EU Data Act",
    url: getLinkToVehicleEuDataAct(minimalVehicle),
  })
  return (
    <div className="page-header">
      <Flex className="!h-12 !pb-2 !justify-between !items-center">
        <Flex className="!h-6 !justify-start !items-center gap-3">
          {icon}
          <div className="text-xl font-semibold">Fahrzeug: {vin}</div>
        </Flex>
      </Flex>
      <div className="page-header-tabs">
        {links.map((linkInfo) => (
          <NavLink
            key={linkInfo.title}
            to={linkInfo.url}
            end={linkInfo.end}
            className="page-header-tab"
          >
            {linkInfo.title}
          </NavLink>
        ))}
      </div>
    </div>
  )
}
